"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Callout = exports.useCallout = exports.CalloutProvider = void 0;
var react_1 = __importDefault(require("react"));
var defaultCallout = {
    message: '',
};
var defaultDuration = 5000;
var animationDuration = 2000; // Should match CSS
var CalloutContext = react_1.default.createContext({
    calloutData: defaultCallout,
    callout: {
        alert: function (message, duration) { },
        success: function (message, duration) { },
    },
});
var CalloutProvider = function (props) {
    var _a = __read(react_1.default.useState(defaultCallout), 2), calloutData = _a[0], setCalloutData = _a[1];
    var animateCallout = function (message, type, duration) {
        var calloutData = {
            message: message,
            status: 'none',
            type: type,
            duration: duration,
        };
        setCalloutData(__assign(__assign({}, calloutData), { status: 'out' }));
        setTimeout(function () {
            setCalloutData(__assign(__assign({}, calloutData), { status: 'in' }));
        }, 10);
        setTimeout(function () {
            setCalloutData(__assign(__assign({}, calloutData), { status: 'out' }));
        }, duration + animationDuration);
        setTimeout(function () {
            setCalloutData(__assign(__assign({}, calloutData), { status: 'done' }));
        }, duration + animationDuration * 2);
    };
    var alert = function (message, duration) {
        if (duration === void 0) { duration = defaultDuration; }
        animateCallout(message, 'alert', duration);
    };
    var success = function (message, duration) {
        if (duration === void 0) { duration = defaultDuration; }
        animateCallout(message, 'success', duration);
    };
    return react_1.default.createElement.apply(react_1.default, __spreadArray([CalloutContext.Provider, { value: { calloutData: calloutData, callout: { alert: alert, success: success } } }], __read(props.children), false));
};
exports.CalloutProvider = CalloutProvider;
var dismissCallout = function (id) {
    var el = document.getElementById(id);
    if (el) {
        el.classList.add('done');
        el.classList.remove('in');
    }
};
var useCallout = function () { return react_1.default.useContext(CalloutContext); };
exports.useCallout = useCallout;
var Callout = function () {
    var calloutData = (0, exports.useCallout)().calloutData;
    return (react_1.default.createElement("div", { className: 'callouts large-6 large-offset-3 small-12 columns' },
        react_1.default.createElement("div", { id: 'callout', className: "callout ".concat(calloutData.type, " ").concat(calloutData.status) },
            react_1.default.createElement("button", { className: 'close-button', onClick: function () { return dismissCallout('callout'); }, type: 'button', style: { color: 'black' } },
                react_1.default.createElement("span", { "aria-hidden": 'true' }, "\u00D7")),
            calloutData.message)));
};
exports.Callout = Callout;
